// src/app/services/[service]/components/game/GameGenres.jsx
import React from "react";
import Image from "next/image";
import styles from "./GameGenres.module.css";
import { gameGenres as staticGameGenres } from "../../data/game-development";

export default function GameGenres({ dynamicData }) {
  // Use dynamic data if available, otherwise fallback to static
  const tag = dynamicData?.tag || "Genre";
  const title = dynamicData?.title || "Genre‑Specific Solutions for Every Need";
  const subtitle = dynamicData?.subtitle || "Discover how we craft solutions specifically designed for the unique needs of each genre.";
  
  const rawItems = dynamicData?.items || staticGameGenres;
  
  // Normalize items to have consistent structure
  const items = rawItems.map(item => {
    let src = item.src || item.image;
    
    if (src && typeof src === 'string') {
      // If it's already a full URL and looks correct, keep it
      if (src.startsWith('http') && src.includes('/uploads/')) {
        // Keep as is, but normalize slashes
        src = src.replace(/\\/g, '/');
      } 
      // If it's a relative path with 'uploads'
      else if (src.includes('uploads')) {
        const baseUrl = (process.env.NEXT_PUBLIC_API_URL || '').replace(/\/api\/?$/, '').replace(/\/$/, '') || '';
        const cleanPath = src.replace(/\\/g, '/').replace(/.*\/uploads\//, 'uploads/');
        src = `${baseUrl}/${cleanPath}`;
      }
    }

    return {
      label: item.label || item.title,
      src: src
    };
  });

  return (
    <section className={`${styles.section} py-5 py-lg-6`}>
      <div className="container">
        <div className="text-center mb-4">
          <span className={styles.eyebrow}>{tag}</span>
          <h2 className={`${styles.title} mt-2`}>
            {title}
          </h2>
          <p className={`${styles.subtitle} mt-2`}>
            {subtitle}
          </p>
        </div>

        <div className={styles.grid}>
          {items.map((g, index) => (
            <article key={index} className={styles.card}>
              <div className={styles.imageWrap}>
                <Image
                  src={g.src || "/placeholder.jpg"}
                  alt={g.label}
                  width={640}
                  height={360}
                  className={styles.image}
                  priority={false}
                  unoptimized={true}
                />
              </div>
              <div className={styles.label}>{g.label}</div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
